import { Validators, FormBuilder } from '@angular/forms';

export let declineDialogValidationMessages: {} = {
  message: {
    'required': 'Данное поле обязательно для заполнения.',
    'pattern': 'В начале лишний пробел.',
  },
  epId: {
    'required': 'Данное поле обязательно для заполнения.',
  },
};

export function getdeclineDialogControlsConfig(model, fb: FormBuilder) {
  return {
    message: [model.message, [Validators.required, Validators.pattern(/^\S+/)]],
    epId: [{value: model.epId, disabled: true}, [Validators.required, Validators.maxLength(191)]],
  };
}





// WEBPACK FOOTER //
// ./src/app/components/dashboard/for-signing/decline/decline.dialog.form.ts